$(document).ready(function() {
  /*setInterval(function() {
    $('.shopLook .grid_img_wr').toggleClass('hoverimage');
  }, 2000);
  $('.hero-home-banner-email').on('click', function (event) {
      event.preventDefault();
    var email = 'info@gallerycouture.com';
    var subject = 'Contact a Stylist';
    var emailBody = '';
    window.location = 'mailto:' + email + '?subject=' + subject + '&body=' +   emailBody;
  });*/

  if (screen.width < 768) {
    $('.collection-banner .cl_desc').expander({
      slicePoint: 130,
      expandText: 'Show More ',
      userCollapseText: 'Show Less ',
    });
  } else {
    $('.collection-banner .cl_desc').expander({
      slicePoint: 250,
      expandText: 'Show More ',
      userCollapseText: 'Show Less ',
    });
  }
  
});